import { Fragment, PropsWithChildren } from 'react';
import { ApolloError } from '@apollo/client';
import LoadingScreen from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/LoadingScreen';
import NoContent from './NoContent';

export type WithQueryProps = PropsWithChildren<{
  loading?: boolean;
  error?: ApolloError | string | boolean | null;
  ErrorComponent?: React.FC<any>;
}>;

const ErrorFallback: any = ({ error }: any) => {
  console.error(error);
  return <NoContent />;
};

const WithQuery = ({
  loading,
  error,
  children,
  ErrorComponent = ErrorFallback,
}: WithQueryProps): React.ReactElement => {
  if (loading) {
    return <LoadingScreen />;
  }

  if (error) return <ErrorComponent error={error} />;

  return <Fragment>{children}</Fragment>;
};

export default WithQuery;
